<div class="w-full max-w-3xl">

    <!-- Form -->
    <div [formGroup]="securityForm">

        <!-- Section -->
        <div class="w-full">
            <div class="text-xl">Cambia tu password</div>
            <div class="text-secondary">Puedes cambiar tu pasword solamente 1 vez cada 24 horas!</div>
        </div>

        <div class="w-full">
            <div class="alert alert-danger" *ngIf="messages">
                {{ messages }}
            </div>
        </div>

        <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
            <!-- Current password -->
            <div class="sm:col-span-4">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Password actual</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:key'" matPrefix></mat-icon>
                    <input [formControlName]="'currentPassword'" type="password" matInput #currentPassword>
                    <button mat-icon-button type="button"
                        (click)="currentPassword.type === 'password' ? currentPassword.type = 'text' : currentPassword.type = 'password'"
                        matSuffix>
                        <mat-icon class="icon-size-5" *ngIf="currentPassword.type === 'password'"
                            [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                        <mat-icon class="icon-size-5" *ngIf="currentPassword.type === 'text'"
                            [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                    </button>
                    <mat-hint class="required-hint">* Campo obligatorio</mat-hint>
                    <mat-error *ngIf="securityForm.controls.currentPassword.errors?.required">Este campo es
                        obligatorio.</mat-error>
                </mat-form-field>
            </div>
            <!-- New password -->
            <div class="sm:col-span-4">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Nuevo password</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:key'" matPrefix></mat-icon>
                    <input [formControlName]="'newPassword'" type="password" matInput #newPassword>
                    <button mat-icon-button type="button"
                        (click)="newPassword.type === 'password' ? newPassword.type = 'text' : newPassword.type = 'password'"
                        matSuffix>
                        <mat-icon class="icon-size-5" *ngIf="newPassword.type === 'password'"
                            [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                        <mat-icon class="icon-size-5" *ngIf="newPassword.type === 'text'"
                            [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                    </button>
                    <mat-hint class="required-hint">Mínimo 8 caracteres. Debe incluir numeros, letras y caracteres
                        especiales.</mat-hint>
                    <mat-error *ngIf="securityForm.controls.newPassword.errors?.required">Este campo es
                        obligatorio.</mat-error>
                    <mat-error *ngIf="securityForm.controls.newPassword.errors?.pattern">La contraseña debe tener al
                        menos 8 caracteres, incluir números, letras mayúsculas y minúsculas, y caracteres
                        especiales.</mat-error>
                </mat-form-field>
                <!-- <div class="mt-1 text-md text-hint">Mínimo 8 caracteres. Debe incluir numeros, letras y caracteres
                    especiales.</div> -->
            </div>
            <div class="sm:col-span-4">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Confirma nuevo password</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:key'" matPrefix></mat-icon>
                    <input [formControlName]="'passwordConfirmation'" type="password" matInput #passwordConfirmation>
                    <button mat-icon-button type="button"
                        (click)="passwordConfirmation.type === 'password' ? passwordConfirmation.type = 'text' : passwordConfirmation.type = 'password'"
                        matSuffix>
                        <mat-icon class="icon-size-5" *ngIf="passwordConfirmation.type === 'password'"
                            [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                        <mat-icon class="icon-size-5" *ngIf="passwordConfirmation.type === 'text'"
                            [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                    </button>
                    <mat-hint class="required-hint">Mínimo 8 caracteres. Debe incluir numeros, letras y caracteres
                        especiales.</mat-hint>
                    <mat-error *ngIf="securityForm.controls.passwordConfirmation.errors?.required">Este campo es
                        obligatorio.</mat-error>
                    <mat-error *ngIf="securityForm.controls.passwordConfirmation.errors?.pattern">La contraseña debe
                        tener al menos 8 caracteres, incluir números, letras mayúsculas y minúsculas, y caracteres
                        especiales.</mat-error>
                </mat-form-field>
                <!-- <div class="mt-1 text-md text-hint">Mínimo 8 caracteres. Debe incluir numeros, letras y caracteres
                    especiales.</div> -->
            </div>
            <div class="sm:col-span-4">
                <div *ngIf="securityForm.errors?.mismatch && securityForm.controls.passwordConfirmation.touched && securityForm.controls.newPassword.touched" class="fuse-mat-no-subscript w-full">
                    <mat-error class="error" class="error error-externo">
                        Las contraseñas deben coincidir.
                    </mat-error>
                </div>
            </div>
        </div>

        <!-- Divider -->
        <div class="my-10 border-t"></div>

        <!-- Actions -->
        <div class="flex items-center justify-end">
            <button (click)="guardarPassword()" [disabled]="!securityForm.valid" class="ml-4" mat-flat-button
                type="button" [color]="'primary'">Guardar
            </button>
        </div>
    </div>

</div>